import remove from 'lodash/remove';
import api from '@/api';

export default {
  namespaced: true,

  state: {
    measuringAttributes: [],
    measuringAttributeTypeOptions: [],
  },

  actions: {
    async GetMeasuringAttributes({ commit }, params) {
      const { measuringAttributes } = await api.measuringAttribute.getMeasuringAttributes(params);
      commit('SET_MEASURINGATTRIBUTES', measuringAttributes);
      return measuringAttributes;
    },
    async GetMeasuringAttributeTypeOptions({ commit }) {
      const { options } = await api.measuringAttribute.getMeasuringAttributeTypeOptions();
      commit('SET_MEASURINGATTRIBUTE_TYPE_OPTIONS', options);
      return options;
    },
    async AddMeasuringAttribute({ commit }, form) {
      const { measuringAttribute } = await api.measuringAttribute.addMeasuringAttribute({ ...form });
      commit('ADD_MEASURINGATTRIBUTE', measuringAttribute);
      return measuringAttribute;
    },
    async UpdateMeasuringAttribute({ commit }, form) {
      const { measuringAttribute } = await api.measuringAttribute.putMeasuringAttribute({ ...form });
      commit('UPDATE_MEASURINGATTRIBUTE', measuringAttribute);
      return measuringAttribute;
    },
    async DeleteMeasuringAttribute({ commit }, measuringAttribute) {
      await api.measuringAttribute.deleteMeasuringAttribute({
        projectId: measuringAttribute.projectId,
        measuringPointId: measuringAttribute.measuringPointId,
        measuringAttributeId: measuringAttribute.id,
      });
      commit('DELETE_MEASURINGATTRIBUTE', measuringAttribute);
    },
  },
  mutations: {
    SET_MEASURINGATTRIBUTES(state, measuringAttributes) {
      state.measuringAttributes = measuringAttributes;
    },
    SET_MEASURINGATTRIBUTE_TYPE_OPTIONS(state, options) {
      state.measuringAttributeTypeOptions = options;
    },
    ADD_MEASURINGATTRIBUTE(state, measuringAttribute) {
      const { measuringAttributes } = state;
      state.measuringAttributes = [...measuringAttributes, measuringAttribute];
    },
    UPDATE_MEASURINGATTRIBUTE(state, measuringAttribute) {
      const { measuringAttributes } = state;
      const target = measuringAttributes.find(item => item.id === measuringAttribute.id);

      if (target) {
        Object.assign(target, measuringAttribute);
        state.measuringAttributes = [...measuringAttributes];
      }
    },
    DELETE_MEASURINGATTRIBUTE(state, measuringAttribute) {
      const { measuringAttributes } = state;
      remove(measuringAttributes, item => item.id === measuringAttribute.id);
      state.measuringAttributes = [...measuringAttributes];
    },
  },
};
